var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" d-flex flex-column justify-center"},[_c('storm-header'),_c('h2',{staticClass:"text-center text-h2"},[_vm._v("Creadores de musica urbana")]),_c('information-section'),_c('buttons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }